import React,{useState} from 'react';
import { motion } from 'framer-motion';
import { FaTimes, FaUser, FaLock, FaSave, FaEye, FaEyeSlash } from 'react-icons/fa';
import PlatformSelector from '../../new-order-components/PlatformSelector';
import { HiChevronDown, HiCheck, HiOutlineUser, HiOutlineMail, HiOutlinePhone, HiOutlineLocationMarker, HiOutlineOfficeBuilding, HiOutlineMailOpen } from 'react-icons/hi';
import ToggleSwitch from './SwitchButton';
import CustomDropdown from './custom-dropdown';

const PersonalInfo = ({ profileData, handleInputChange, errors, isSaving }) => {

  const [showPassword, setShowPassword] = useState(false);



  // Input animation variants
  const inputVariants = {
    focus: { scale: 1.01, transition: { duration: 0.2 } },
    blur: { scale: 1, transition: { duration: 0.2 } }
  };

  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-xl font-semibold text-gray-900 flex items-center">
          <svg className="w-5 h-5 mr-2 text-[#174540]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
          Informations Personnelles
        </h3>
       
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* First Name */}
        <div className="group">
          <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2 group-hover:text-[#174540] transition-colors duration-200">
            Prénom
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
            </div>
            <motion.input
              type="text"
              name="firstName"
              id="firstName"
              variants={inputVariants}
              whileFocus="focus"
              className={`block w-full pl-10 pr-10 py-3 shadow-sm bg-white rounded-lg border-0 ring-1 ring-inset focus:outline-none sm:text-sm ${
                errors.firstName
                  ? 'ring-red-300 text-red-900 placeholder-red-300 focus:ring-red-500'
                  : 'ring-gray-200 text-gray-900 placeholder-gray-400 focus:ring-[#174540] group-hover:ring-gray-300'
              } transition-shadow duration-200`}
              placeholder="Entrez votre prénom"
              value={profileData?.firstName || ''}
              onChange={handleInputChange}
              disabled={isSaving}
              style={{ boxShadow: errors.firstName ? '0 0 0 1px rgba(248, 113, 113, 0.3)' : '0 1px 2px rgba(0, 0, 0, 0.05)' }}
            />
            {errors.firstName && (
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
            )}
          </div>
          {errors.firstName && (
            <motion.p 
              initial={{ opacity: 0, y: -10 }} 
              animate={{ opacity: 1, y: 0 }} 
              className="mt-2 text-sm text-red-600 flex items-center"
            >
              <svg className="h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors.firstName}
            </motion.p>
          )}
        </div>

        {/* Last Name */}
        <div className="group">
          <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2 group-hover:text-[#174540] transition-colors duration-200">
            Nom
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <motion.input
              type="text"
              name="lastName"
              id="lastName"
              variants={inputVariants}
              whileFocus="focus"
              className={`block w-full pl-10 pr-10 py-3 shadow-sm bg-white rounded-lg border-0 ring-1 ring-inset focus:outline-none sm:text-sm ${
                errors.lastName
                  ? 'ring-red-300 text-red-900 placeholder-red-300 focus:ring-red-500'
                  : 'ring-gray-200 text-gray-900 placeholder-gray-400 focus:ring-[#174540] group-hover:ring-gray-300'
              } transition-shadow duration-200`}
              placeholder="Entrez votre nom"
              value={profileData?.lastName || ''}
              onChange={handleInputChange}
              disabled={isSaving}
              style={{ boxShadow: errors.lastName ? '0 0 0 1px rgba(248, 113, 113, 0.3)' : '0 1px 2px rgba(0, 0, 0, 0.05)' }}
            />
            {errors.lastName && (
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
            )}
          </div>
          {errors.lastName && (
            <motion.p 
              initial={{ opacity: 0, y: -10 }} 
              animate={{ opacity: 1, y: 0 }} 
              className="mt-2 text-sm text-red-600 flex items-center"
            >
              <svg className="h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors.lastName}
            </motion.p>
          )}
        </div>

        {/* Email */}
        <div className="group">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2 group-hover:text-[#174540] transition-colors duration-200">
            Email
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
              </svg>
            </div>
            <motion.input
              type="email"
              name="email"
              id="email"
              variants={inputVariants}
              whileFocus="focus"
              className={`block w-full pl-10 pr-10 py-3 shadow-sm bg-white rounded-lg border-0 ring-1 ring-inset focus:outline-none sm:text-sm ${
                errors.email
                  ? 'ring-red-300 text-red-900 placeholder-red-300 focus:ring-red-500'
                  : 'ring-gray-200 text-gray-900 placeholder-gray-400 focus:ring-[#174540] group-hover:ring-gray-300'
              } transition-shadow duration-200`}
              placeholder="votre@email.com"
              value={profileData?.email || ''}
              onChange={handleInputChange}
              disabled={isSaving}
              style={{ boxShadow: errors.email ? '0 0 0 1px rgba(248, 113, 113, 0.3)' : '0 1px 2px rgba(0, 0, 0, 0.05)' }}
            />
            {errors.email && (
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
            )}
          </div>
          {errors.email && (
            <motion.p 
              initial={{ opacity: 0, y: -10 }} 
              animate={{ opacity: 1, y: 0 }} 
              className="mt-2 text-sm text-red-600 flex items-center"
            >
              <svg className="h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors.email}
            </motion.p>
          )}
        </div>

        <div className="space-y-1.5">
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700 flex items-center">
                      Mot de passe
                    </label>
                    
                    <div className="relative group">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <FaLock className="h-4 w-4 text-gray-400" />
                      </div>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="passwordHash"
                        id="password"
                        value={profileData.passwordHash}
                        onChange={handleInputChange}
                        placeholder="Minimum 6 caractères"
                        className={`pl-10 pr-10 block w-full rounded-lg border ${
                          errors.passwordHash 
                            ? 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500' 
                            : 'border-gray-300 focus:border-emerald-500 focus:ring-emerald-500'
                        } transition-colors sm:text-sm py-2.5`}
                        aria-invalid={errors.passwordHash ? "true" : "false"}
                        aria-describedby={errors.passwordHash ? "password-error" : undefined}
                      />
                      <button
                        type="button"
                        tabIndex="-1"
                        className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
                        onClick={() => setShowPassword(!showPassword)}
                        aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                      >
                        {showPassword ? <FaEyeSlash className="h-4 w-4" /> : <FaEye className="h-4 w-4" />}
                      </button>
                      {errors.passwordHash && (
                        <div className="absolute right-0 top-0 bottom-0 w-1 bg-red-500 rounded-r-lg"></div>
                      )}
                    </div>
                    
                    {errors.passwordHash && (
                      <p className="mt-1 text-sm text-red-600 flex items-start" id="password-error">
                        <svg className="h-4 w-4 mr-1 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.passwordHash}
                      </p>
                    )}
                  </div>


        {/* Phone Number */}
        <div className="group">
          <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700 mb-2 group-hover:text-[#174540] transition-colors duration-200">
            Téléphone
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
              </svg>
            </div>
            <motion.input
              type="tel"
              name="phoneNumber"
              id="phoneNumber"
              variants={inputVariants}
              whileFocus="focus"
              className={`block w-full pl-10 pr-10 py-3 shadow-sm bg-white rounded-lg border-0 ring-1 ring-inset focus:outline-none sm:text-sm ${
                errors.phoneNumber
                  ? 'ring-red-300 text-red-900 placeholder-red-300 focus:ring-red-500'
                  : 'ring-gray-200 text-gray-900 placeholder-gray-400 focus:ring-[#174540] group-hover:ring-gray-300'
              } transition-shadow duration-200`}
              placeholder="+216 XX XXX XXX"
              value={profileData?.phoneNumber || ''}
              onChange={handleInputChange}
              disabled={isSaving}
              style={{ boxShadow: errors.phoneNumber ? '0 0 0 1px rgba(248, 113, 113, 0.3)' : '0 1px 2px rgba(0, 0, 0, 0.05)' }}
            />
            {errors.phoneNumber && (
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
            )}
          </div>
          {errors.phoneNumber && (
            <motion.p 
              initial={{ opacity: 0, y: -10 }} 
              animate={{ opacity: 1, y: 0 }} 
              className="mt-2 text-sm text-red-600 flex items-center"
            >
              <svg className="h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors.phoneNumber}
            </motion.p>
          )}
        </div>

                                        {/* Platform selector component */}
                                {/* <div className="group">
                                    <PlatformSelector
                                        selectedPlatform={profileData.platformId}
                                        onChange={handleInputChange}
                                        error={errors.platformId}
                                    />
                                </div> */}
                                <div className="group">

                                <CustomDropdown
      selectedPlatform={profileData.plateformId}
      onChange={handleInputChange}
      error={errors.plateformId}
      icon={HiOutlineOfficeBuilding}
    />

</div>

        {/* Date of Birth */}
        <div className="group">
          <label htmlFor="dateOfBirth" className="block text-sm font-medium text-gray-700 mb-2 group-hover:text-[#174540] transition-colors duration-200">
            Date de naissance
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
            </div>
            <motion.input
              type="date"
              name="dateOfBirth"
              id="dateOfBirth"
              variants={inputVariants}
              whileFocus="focus"
              className={`block w-full pl-10 pr-3 py-3 shadow-sm bg-white rounded-lg border-0 ring-1 ring-inset ${
                errors.dateOfBirth
                  ? 'ring-red-300 text-red-900 placeholder-red-300 focus:ring-red-500'
                  : 'ring-gray-200 text-gray-900 placeholder-gray-400 focus:ring-[#174540] group-hover:ring-gray-300'
              } transition-shadow duration-200`}
              value={profileData?.dateOfBirth ? new Date(profileData.dateOfBirth).toISOString().split('T')[0] : ''}
              onChange={(e) => {
                const dateValue = e.target.value;
                // If date is selected, convert to ISO format with time to ensure it's a proper datetime
                // This adds the time component (T00:00:00.000Z) needed for backend
                const datetimeValue = dateValue ? new Date(`${dateValue}T00:00:00.000Z`).toISOString() : '';
                
                // Create a synthetic event to match the expected format of handleInputChange
                const syntheticEvent = {
                  target: {
                    name: 'dateOfBirth',
                    value: datetimeValue
                  }
                };
                
                handleInputChange(syntheticEvent);
              }}
              disabled={isSaving}
              style={{ boxShadow: errors.dateOfBirth ? '0 0 0 1px rgba(248, 113, 113, 0.3)' : '0 1px 2px rgba(0, 0, 0, 0.05)' }}
              max={new Date().toISOString().split('T')[0]} // Prevent future dates
            />
            {errors.dateOfBirth && (
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
            )}
          </div>
          {errors.dateOfBirth &&
            <motion.p 
              initial={{ opacity: 0, y: -10 }} 
              animate={{ opacity: 1, y: 0 }} 
              className="mt-2 text-sm text-red-600 flex items-center"
            >
              <svg className="h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors.dateOfBirth}
            </motion.p>
          }
        </div>

        {/* Username */}
        <div className="group">
          <label htmlFor="userName" className="block text-sm font-medium text-gray-700 mb-2 group-hover:text-[#174540] transition-colors duration-200">
            Nom d'utilisateur
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"></path>
              </svg>
            </div>
            <motion.input
              type="text"
              name="userName"
              id="userName"
              variants={inputVariants}
              whileFocus="focus"
              className="block w-full pl-10 pr-3 py-3 shadow-sm bg-white rounded-lg border-0 ring-1 ring-inset ring-gray-200 focus:ring-[#174540] text-gray-900 placeholder-gray-400 focus:outline-none sm:text-sm group-hover:ring-gray-300 transition-shadow duration-200"
              placeholder="Votre nom d'utilisateur"
              value={profileData?.userName || ''}
              onChange={handleInputChange}
              disabled={isSaving}
              style={{ boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)' }}
            />
          </div>
        </div>




        {/* Account Type */}
        {/* <div className="group">
          <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-2 group-hover:text-[#174540] transition-colors duration-200">
            Type de compte
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
              </svg>
            </div>
            <select
              id="type"
              name="type"
              className="appearance-none block w-full pl-10 pr-10 py-3 shadow-sm bg-white rounded-lg border-0 ring-1 ring-inset ring-gray-200 focus:ring-[#174540] text-gray-900 placeholder-gray-400 focus:outline-none sm:text-sm group-hover:ring-gray-300 transition-shadow duration-200"
              value={profileData?.type || ''}
              onChange={handleInputChange}
              disabled={isSaving}
            >
              <option value="">Sélectionner un type</option>
              <option value="client">Client</option>
              <option value="admin">Administrateur</option>
              <option value="employee">Employé</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
              </svg>
            </div>
          </div>
        </div> */}


                  <div className="group space-y-1.5">

<ToggleSwitch value={profileData.active} handleInputChange={handleInputChange}/>
                                </div>





 
      </div>
    </div>
  );
};

export default PersonalInfo;